import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useCart } from '../context/CartContext';
import { fetchProducts } from '../utils/api';
import Loading from '../components/Loading';
import { FaPlus, FaMinus, FaCartPlus  } from "react-icons/fa";
import DiscountDropdown from '../components/DiscountDropdown';

const StorePage = () => {
    const { addToCart, incrementItem, decrementItem, cartItems } = useCart();
    const [products, setProducts] = useState([]);

    useEffect(() => {
        const getProducts = async () => {
            try {
                const data = await fetchProducts();
                setProducts(data);
            } catch (error) {
                console.error("Feil ved henting av produkter:", error);
            }
        };
        getProducts();
    }, []);

    const isInCart = (cartItems, productId) => {
        return cartItems.find(item => item._id === productId);
    }

    const handleAddToCart = (product) => {
        addToCart(product);
    };

    
    
    return (
        <>
            <meta name="description" content="Utforsk vårt store utvalg av ferske bær. Bestill norske jordbær, bringebær, moreller og mer!" />
            <meta property="og:title" content="Wildberries Butikk | Kjøp Ferske Norske Bær" />
            <meta property="og:description" content="Få de beste norske bærene levert til deg!" />
            <meta property="og:image" content="/images/store-preview.jpg" />
            <meta property="og:url" content="https://wildberries.no/shop" />

            <ShopContainer>
                <h2 className="section-title">Vårt Utvalg Av Bær</h2>
                <div className="section-border"></div>
                
                {products.length > 0 ? (
                        <ProductGrid>
                            {products.map(product => {
                                const cartItem = isInCart(cartItems, product._id)
                                return (
                                    <ProductCard key={product._id}>
                                        {product.bulkDiscounts && product.bulkDiscounts.length > 0 && (
                                            <DiscountBadge>
                                                Tilbud
                                            </DiscountBadge>
                                        )}
                                        <ProductImage src={product.image} alt={product.name} />
                                        <ProductInfo>
                                            <ProductName>{product.name}</ProductName>
                                            <ProductPrice>{product.price} NOK</ProductPrice>
                                        </ProductInfo>
                                            <ProductDescription>{product.description}</ProductDescription>
                                            
                                            {product.bulkDiscounts && product.bulkDiscounts.length > 0 && (
                                                <DiscountDropdown bulkDiscounts={product.bulkDiscounts} />
                                            )}

                                            {cartItem ? (
                                                <QuantityControls>
                                                    <Button onClick={() => decrementItem(product._id)}><FaMinus /></Button>
                                                    <Quantity>{cartItem.quantity}</Quantity>
                                                    <Button onClick={() => incrementItem(product._id)}><FaPlus /></Button>
                                                </QuantityControls>
                                            ) : (
                                                <AddToCartButton
                                                    onClick={() => handleAddToCart(product)}
                                                >
                                                    <FaCartPlus size={22}/>
                                                </AddToCartButton>
                                            )}
                                    </ProductCard>
                                )
                            })}
                        </ProductGrid>
                ) : <Loading />}
                    
            </ShopContainer>
        </>
    )
}

export default StorePage

const ShopContainer = styled.section`
    padding: 4rem 0;
    min-height: 100vh;
    max-width: 1200px;
    margin: 0 auto;

    @media (min-width: 1600px){
        max-width: 1600px;
    }
`;

const ProductGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1rem;
    justify-content: center;
    padding: 0 1rem;
    max-width: 1000px;
    margin: 0 auto;

    @media (max-width: 768px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 480px) {
        grid-template-columns: 1fr;
    }

    .loading {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
    }
`;

const ProductCard = styled.div`
    background: white;
    border-radius: 8px;
    padding: 1rem;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease;
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;

    &:hover {
        transform: translateY(-5px);
    }
`;

const DiscountBadge = styled.div`
    position: absolute;
    top: 0px;
    left: -5px;
    background: #d32f2f;
    color: white;
    font-size: 10px;
    font-weight: bold;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    text-transform: uppercase;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
`;


const ProductImage = styled.img`
    width: 100%;
    max-height: 350px;
    object-fit: contain;
    border-radius: 8px;
    margin-bottom: 1rem;
`;

const ProductInfo = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 10px;
    margin-bottom: 1rem;
    
`;

const ProductName = styled.h3`
    font-family: 'Poppins', sans-serif;
    color: #4a3a29;
    font-size: .9rem;
    flex: 1;
    word-wrap: break-word;

    @media (max-width: 480px) {
        font-size: .8rem;
    }
`;

const ProductDescription = styled.p`
    font-size: 0.8rem;
    color: #807d7d;
    margin-bottom: 1rem;


    @media (max-width: 480px) {
        font-size: .7rem;   
    }
`;

const ProductPrice = styled.div`
    font-size: 1rem;
    color: #B22222;
    font-weight: 600;
    white-space: nowrap;

    @media (max-width: 480px) {
        font-size: .97rem;   
    }
`;

const AddToCartButton = styled.button`
    background: #B22222;
    color: white;
    border: none;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    align-self: flex-end;
    margin-top: auto;
    display: flex;
    justify-content: center;
    align-items: center;

    &:hover {
        background: #991b1b;
    }

    @media (max-width: 480px) {
        padding: 6px 10px;
    }
`;

const QuantityControls = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    margin-top: auto;
    align-self: flex-end;
`;

const Button = styled.button`
    background: #2d6a4f;
    color: white;
    border: none;
    padding: 8px 10px;
    border-radius: 4px;
    cursor: pointer;
    transition: background 0.3s;

    &:hover {
        background: #1b4332;
    }
`;

const Quantity = styled.span`
    font-size: 1.2rem;
    font-weight: bold;
`;